import { ProgramEventDetail, ProgramEventHeader, ProgramEventLayout } from 'features/events';
import { useFeedbackOptions } from '../../../hooks';
import { useNavigateToCalendar, useRedirectToEventDetail } from '../../hooks';

type P = {
  eventId: string;
};

const ProgramEventDetailContent = ({ eventId }: P) => {
  const redirectToEventDetail = useRedirectToEventDetail();
  const navigateToCalendar = useNavigateToCalendar();
  const feedbackOptions = useFeedbackOptions();

  return (
    <ProgramEventLayout
      eventId={eventId}
      header={(eventContentObject) => (
        <ProgramEventHeader eventContentObject={eventContentObject} onEventDeleted={navigateToCalendar} />
      )}
      redirectToEventDetail={redirectToEventDetail}
    >
      {(eventContentObject) => (
        <ProgramEventDetail eventContentObject={eventContentObject} feedbackOptions={feedbackOptions} />
      )}
    </ProgramEventLayout>
  );
};

export default ProgramEventDetailContent;
